export default "__VITE_ASSET__CeC95xxK__"